import { asyncHandler } from '../async-handler';
import store from '../../../store/store';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import {
  CHECK_CONNECTION_API,
  GET_TRACKER_INTEGRATIONS_API,
} from '../../constants/central-api';
import {
  setAiOnboardingSelectedIntegrate,
  setIsTrackingScriptConnectionSuccess,
} from '../../../store/reducers/userSlice';
import isNotEmptyString from '../../helper-functions/isNotEmptyString';
import { applicationWWWXRLEncodedBodyBuilder } from '../../utils/body-builder';

export default async function get_checkout_tracking_api_call(
  checkScriptConnection: boolean = false
) {
  const accessToken = store.getState().auth.authorization.accessToken;
  const shopSlug = store.getState().user?.company?.shop_slug;
  const shopURL = store.getState().user?.company?.webshop_url;

  const sellerToken = accessToken?.sellerToken;

  if (!shopSlug) {
    return false;
  }

  const requestInfo: RequestInfo = {
    url: `${GET_TRACKER_INTEGRATIONS_API(shopSlug)}`,
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/json',
      Authorization: accessToken.type + ' ' + sellerToken,
    },
  };

  const actionType = 'GET_CHECKOUT_TRACKING_DATA';
  const customMsg = 'Available Checkout Tracking Data Loaded Successfully.';

  const res: any = await asyncHandler(
    requestInfo,
    actionType,
    customMsg,
    false
  );

  const response = res?.data;
  if (!response.success) {
    return false;
  }
  if (res.actionType === actionType && response.success === true) {
    if (response.data === null) {
      return {};
    } else {
      if (response?.data?.additional_configs?.CMS_type === 'shopify') {
        store.dispatch(setAiOnboardingSelectedIntegrate('shopify'));
      }
      //* Fetch tracking script connection status
      if (checkScriptConnection) {
        const apiKey = response?.data?.api_key ?? undefined;
        const isTrackerActive =
          response?.data?.additional_configs?.is_tracker_active === 'true'
            ? true
            : false;

        if (
          isNotEmptyString(apiKey) &&
          isNotEmptyString(shopURL) &&
          isTrackerActive
        ) {
          try {
            const sendingData = {
              tracking_id: apiKey,
              site_url: shopURL,
            };

            const requestInfo: RequestInfo = {
              url: CHECK_CONNECTION_API,
              method: 'POST',
              body: applicationWWWXRLEncodedBodyBuilder(sendingData),
              headers: {
                Accept: 'application/json',
                'Content-type': 'application/x-www-form-urlencoded',
              },
            };

            const actionType = 'CHECK_CONNECTION_API';
            const customMsg = '';

            const res: any = await asyncHandler(
              requestInfo,
              actionType,
              customMsg,
              false,
              false,
              false,
              false,
              [],
              true
            );

            const response = res.data;

            if (
              res.actionType === actionType &&
              response?.success === true &&
              response?.data?.script_detected
            ) {
              store.dispatch(setIsTrackingScriptConnectionSuccess('true'));
            } else {
              store.dispatch(setIsTrackingScriptConnectionSuccess('false'));
            }
          } catch (error) {
            console.error('Error fetching script connection data:', error);
            store.dispatch(setIsTrackingScriptConnectionSuccess('false'));
          }
        } else {
          store.dispatch(setIsTrackingScriptConnectionSuccess('false'));
        }
      }
      return response?.data;
    }
  }
}
